export class StorageService {
  private static readonly FAVORITES_KEY = 'live-shuffle-favorites';
  private static readonly SETTINGS_KEY = 'live-shuffle-settings';
  private static readonly PREVIOUS_SESSION_KEY = 'live-shuffle-previous-session';
  private static readonly FEATURED_KEY = 'live-shuffle-featured';

  static async getFavorites(): Promise<string> {
    return localStorage.getItem(this.FAVORITES_KEY) || '';
  }

  static async setFavorites(data: string): Promise<void> {
    localStorage.setItem(this.FAVORITES_KEY, data);
  }

  static async clearFavorites(): Promise<void> {
    localStorage.removeItem(this.FAVORITES_KEY);
  }

  static async getSettings(): Promise<string> {
    return localStorage.getItem(this.SETTINGS_KEY) || '';
  }

  static async setSettings(data: string): Promise<void> {
    localStorage.setItem(this.SETTINGS_KEY, data);
  }

  static async clearSettings(): Promise<void> {
    localStorage.removeItem(this.SETTINGS_KEY);
  }

  static async getPreviousSession(): Promise<string> {
    return localStorage.getItem(this.PREVIOUS_SESSION_KEY) || '';
  }

  static async setPreviousSession(data: string): Promise<void> {
    localStorage.setItem(this.PREVIOUS_SESSION_KEY, data);
  }

  static async clearPreviousSession(): Promise<void> {
    localStorage.removeItem(this.PREVIOUS_SESSION_KEY);
  }

  static async getFeatured(): Promise<string> {
    return localStorage.getItem(this.FEATURED_KEY) || '';
  }

  static async setFeatured(data: string): Promise<void> {
    localStorage.setItem(this.FEATURED_KEY, data);
  }

  static async clearFeatured(): Promise<void> {
    localStorage.removeItem(this.FEATURED_KEY);
  }
}